import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopAdoptables from './ShopAdoptables';

export const getShopAdoptablesWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: ShopAdoptables,
});
